import React from "react";

import {
  Mail,
  Phone,
  BrandLinkedin,
  BrandGithub,
  Check,
} from "tabler-icons-react";
import { createStyles, Container, Group, Tooltip } from "@mantine/core";
import {
  NotificationsProvider,
  showNotification,
} from "@mantine/notifications";

const useStyles = createStyles((theme) => ({
  sectionHeader: {
    textAlign: "center",
    fontSize: "108px",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "bolder",

    [theme.fn.smallerThan(860)]: {
      fontSize: "64px",
    },
  },
  contact: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  link: {
    color: "black",

    "&:hover": {
      backgroundColor: "#FAEBD7",
      cursor: "pointer",
    },
  },
  col: {
    paddingLeft: "112px",

    [theme.fn.smallerThan(579)]: {
      padding: "0",
    },
  },
  contactContainer: {
    display: "flex",
    alignItems: "center",
    gap: "100px",

    [theme.fn.smallerThan(860)]: {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
  },
}));

const Contact = () => {
  const { classes } = useStyles();

  const open = (e: any, url: string) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  const copy = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        showNotification({
          title: "Copied to clipboard!",
          message: "Now go paste it!",
          color: "green",
          autoClose: 5000,
          icon: <Check />,
        });
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      }
    );
  };

  return (
    <Container id="contact" size="xl">
      <NotificationsProvider>
        <div className={classes.contactContainer}>
          <div className={classes.sectionHeader}>Contact</div>
          <div className={classes.contact}>
            <Group spacing="xl">
              <Mail size={24} strokeWidth={2} color={"black"} />
              <Tooltip label="Click to copy!" withArrow>
                <div
                  onClick={() => copy("ho.d.benjamin@gmail.com")}
                  className={classes.link}
                >
                  ho.d.benjamin@gmail.com
                </div>
              </Tooltip>
            </Group>
            <Group spacing="xl">
              <Phone size={24} strokeWidth={2} color={"black"} />
              <Tooltip label="Click to copy!" withArrow>
                <div
                  onClick={() => copy("(650) 815-6303")}
                  className={classes.link}
                >
                  (650) 815-6303
                </div>
              </Tooltip>
            </Group>
            <Group spacing="xl">
              <BrandLinkedin size={24} strokeWidth={2} color={"black"} />
              <a
                className={classes.link}
                href="/"
                onClick={(e) =>
                  open(e, "https://www.linkedin.com/in/benjadho/")
                }
              >
                https://www.linkedin.com/in/benjadho/
              </a>
            </Group>
            <Group spacing="xl">
              <BrandGithub size={24} strokeWidth={2} color={"black"} />
              <a
                className={classes.link}
                href="/"
                onClick={(e) => open(e, "https://github.com/benjaminho1998")}
              >
                https://github.com/benjaminho1998
              </a>
            </Group>
          </div>
        </div>
      </NotificationsProvider>
    </Container>
  );
};

export default Contact;
